exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#pickup-checkout .shipping-address {\n  width: 100%;\n}\n#pickup-checkout .shipping-address .vti__dropdown {\n    left: 5px;\n}\n#pickup-checkout .shipping-address .phoneinput input {\n    padding-left: 100px;\n}\n#pickup-checkout .shipping-address .phoneinput label {\n    left: 90px;\n    top: 12px;\n}\n.textarea-custom-for-gift {\n  max-height: 52px;\n}\n.textarea-custom-for-gift textarea {\n    border: none;\n    min-height: 55px;\n    margin-top: 0;\n}\n", ""]);

// exports
